import {IReducersMap, reducer} from '../../standard-actions/reducers'
import {
  REQUEST_FEATURE_FLAGS,
  SELF_SERVICE_STORE_BREADCRUMB,
  ORDER_LOAD_SUMMARY,
  GET_ACTIVE_SERVICES,
  GET_CABLE_TYPE,
  GET_SERVICE_IDS,
  UPDATE_CONFIG_DETAILS,
  CONNECTOR_TYPES,
  GET_CART_ITEMS,
  FILE_UPLOAD,
  GET_BILLING_ACCOUNT_DETAILS,
  ADD_TO_CART,
  GET_CABLES_PRICE,
  GET_CURRENCY_EXCHANGE,
  SUBMIT_ORDER,
  GET_COMPLETE_CURRENCY_EXCHANGE,
  SELF_SERVICE_STORE_ABLE_BREADCRUMB
} from '../actions/action-types'
import {IStoreIntState} from '../state'
import {initialState} from '../state/initial-state'
import {LoadFeatureFlagsAction, loadFeatureFlagsReducer} from './load-feature-flags'
import { UpdateAbleBreadcrumbAction, UpdateBreadcrumbAction ,updateAbleBreadcrumbReducer,updateBreadcrumbReducer } from './update-breadcrumb';
import { LoadOrderSummaryAction, loadOrderSummaryReducer } from './load-order-summary'
import { LoadCableTypesAction, loadCableTypesReducer } from './cable-type-details-reducer'
import { LoadServiceIdsAction, loadServiceIdsReducer } from './services-ids-reducer'
import { LoadActiveServicesAction,loadActiveServicesReducer } from './load-active-services'
import { UpdateCableConfigAction ,updateCableConfigReducer } from './update-cable-config';
import { LoadConnectorTypesAction ,loadConnectorTypesReducer } from './load-connector-types';
import { getCartReducer ,LoadCartAction  } from './get-cart-items'
import { fileUploadReducer } from './file-upload-reducer';
import {LoadBillingAccountsAction ,loadBillingAccountsReducer } from './billing-accounts-reducer'
import { addToCart, AddToCartAction } from './add-to-cart'
import { GetCablePriceAction, getCablesPriceReducers } from './get-cables-price-reducer'
import { getCurrencyRateReducers } from './get-currency-rate-reducer'
import { submitOrder, SubmitOrderAction } from './submit-order'
import { getCompleteCurrencyRateReducers } from './get-complete-currency-rate-reducer'
export type StoreIntAction =
  | LoadFeatureFlagsAction
  | LoadOrderSummaryAction
  | LoadActiveServicesAction
  | LoadCableTypesAction
  | LoadServiceIdsAction
  | UpdateCableConfigAction
  | UpdateBreadcrumbAction
  | UpdateAbleBreadcrumbAction
  | LoadConnectorTypesAction
  | LoadCartAction
  | LoadBillingAccountsAction
  | AddToCartAction
  | GetCablePriceAction
  | SubmitOrderAction

const reducersMap: IReducersMap<IStoreIntState> = {
  [REQUEST_FEATURE_FLAGS]: loadFeatureFlagsReducer,
  [SELF_SERVICE_STORE_BREADCRUMB]: updateBreadcrumbReducer,
  [SELF_SERVICE_STORE_ABLE_BREADCRUMB]: updateAbleBreadcrumbReducer,
  [UPDATE_CONFIG_DETAILS] : updateCableConfigReducer,
  [ORDER_LOAD_SUMMARY]: loadOrderSummaryReducer,
  [GET_ACTIVE_SERVICES]: loadActiveServicesReducer,
  [GET_CABLE_TYPE]: loadCableTypesReducer,
  [GET_SERVICE_IDS] : loadServiceIdsReducer,
  [CONNECTOR_TYPES] : loadConnectorTypesReducer,
  [GET_CART_ITEMS] : getCartReducer,
  [FILE_UPLOAD]: fileUploadReducer,
  [GET_BILLING_ACCOUNT_DETAILS] : loadBillingAccountsReducer,
  [ADD_TO_CART] : addToCart,
  [GET_CABLES_PRICE] : getCablesPriceReducers,
  [GET_CURRENCY_EXCHANGE]: getCurrencyRateReducers,  
  [SUBMIT_ORDER] : submitOrder,
  [GET_COMPLETE_CURRENCY_EXCHANGE]: getCompleteCurrencyRateReducers
}

export const storeIntReducer = reducer<IStoreIntState, StoreIntAction>(
  reducersMap,
  initialState,
)
